import { useState, useEffect, useCallback } from 'react';
import { Button, Upload, message, Spin } from 'antd';
import { UploadOutlined, ReloadOutlined, ExportOutlined } from '@ant-design/icons';
import { getDashboard, getData, getFilters, uploadExcel } from '../../api';
import KpiCards from '../../components/KpiCards';
import FilterBar from '../../components/FilterBar';
import ChartsPanel from '../../components/ChartsPanel';
import DataTable from '../../components/DataTable';

export default function JjReport() {
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [dashboard, setDashboard] = useState(null);
  const [filters, setFilters] = useState({});
  const [activeFilters, setActiveFilters] = useState({});

  const loadDashboard = useCallback(async (f = {}) => {
    setLoading(true);
    try {
      const [dashRes, filtRes] = await Promise.all([getDashboard(f), getFilters()]);
      setDashboard(dashRes.data);
      setFilters(filtRes.data);
    } catch { message.error('加载看板数据失败'); }
    setLoading(false);
  }, []);

  useEffect(() => { loadDashboard(); }, [loadDashboard]);

  const handleImport = async (file) => {
    setUploading(true);
    try {
      const res = await uploadExcel(file);
      if (res.data.success) {
        message.success(res.data.message);
        await loadDashboard(activeFilters);
      } else {
        message.error(res.data.message);
      }
    } catch { message.error('导入失败'); }
    setUploading(false);
    return false;
  };

  const handleFilterChange = (newFilters) => {
    setActiveFilters(newFilters);
    loadDashboard(newFilters);
  };

  const handleExport = async () => {
    try {
      const res = await getData({ ...activeFilters, page: 1, page_size: 10000 });
      const rows = res.data.data;
      if (!rows.length) return message.warning('无数据可导出');
      const headers = Object.keys(rows[0]);
      const csv = [
        headers.join(','),
        ...rows.map(r => headers.map(h => {
          const v = r[h];
          if (v === null || v === undefined) return '';
          const s = String(v);
          return s.includes(',') || s.includes('"') ? `"${s.replace(/"/g, '""')}"` : s;
        }).join(',')),
      ].join('\n');
      const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `经销商采购计划_${new Date().toISOString().slice(0, 10)}.csv`;
      a.click();
      URL.revokeObjectURL(url);
      message.success('导出成功');
    } catch { message.error('导出失败'); }
  };

  if (loading && !dashboard) {
    return <div className="loading-overlay"><Spin size="large" tip="加载中..." /></div>;
  }

  return (
    <>
      <div className="filter-bar">
        <Upload accept=".xlsx,.xls" showUploadList={false} beforeUpload={handleImport}>
          <Button type="primary" icon={<UploadOutlined />} loading={uploading}>导入 Excel</Button>
        </Upload>
        <Button icon={<ReloadOutlined />} onClick={() => loadDashboard(activeFilters)}>刷新</Button>
        <Button icon={<ExportOutlined />} onClick={handleExport}>导出</Button>
        <div style={{ flex: 1 }} />
        {filters.years && (
          <FilterBar filters={filters} active={activeFilters} onChange={handleFilterChange} />
        )}
      </div>
      {dashboard && (
        <>
          <KpiCards stats={dashboard.stats} />
          <ChartsPanel data={dashboard} />
          <DataTable filters={activeFilters} />
        </>
      )}
    </>
  );
}
